import { useContext } from 'react';
import { OrgContext, type OrgContextValue } from '../state/OrgContext';

export type UseOrgResult = OrgContextValue;

export function useOrg(): UseOrgResult {
  return useContext(OrgContext);
}
